import { Divider } from "@mui/material";
import * as React from "react";
import { useContext } from "react";
import { SWITCH_TAB_TYPE, SwitchTabs } from "../../../common/SwitchTabs";
import { GroupChatListPanelHeader } from "../../GroupChatListPanelHeader";
import { GroupChatListPanelHeaderWrapper } from "./PatientChats.styles";
import PatientGroupChatList from "./PatientGroupChatList";
import { FilteredPatientChatsContext } from "hhn-commons";
import { CHAT_DETAILS } from "./PatientChats";

type PatientChatListSearchViewProps = {
  selectedChatId?: string;
  chatItemView: CHAT_DETAILS;
  setChatItemView: (view: CHAT_DETAILS) => void;
};

export const PatientChatListSearchView = ({
  selectedChatId,
  chatItemView,
  setChatItemView,
}: PatientChatListSearchViewProps) => {
  const { chatData, isChatLoading, fetchChats } = useContext(
    FilteredPatientChatsContext,
  );

  return (
    <>
      <Divider />
      <GroupChatListPanelHeaderWrapper>
        <GroupChatListPanelHeader
          unreadChatCount={chatData?.unreadChatCount || 0}
          searchResultCount={chatData?.searchMatchCount}
          listSize={(chatData?.chats || []).length}
        />

        <SwitchTabs
          type={SWITCH_TAB_TYPE.MESSAGES}
          onTabValueChange={setChatItemView}
        />
      </GroupChatListPanelHeaderWrapper>
      <Divider />
      <PatientGroupChatList
        chats={chatData?.chats || []}
        selectedChatId={selectedChatId}
        isChatLoading={isChatLoading}
        fetchChatList={fetchChats}
        showChatDetails={chatItemView}
        isMoreChats={chatData?.hasNext}
      />
    </>
  );
};
